import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Grid,
  Paper,
  FormControl,
  Input,
  InputAdornment,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { find, findIndex, cloneDeep, filter, includes } from 'lodash';
import TherapeuticCategory from './TherapeuticCategory';
import CategoryUpsert from './CategoryUpsert';
import { dialogModes } from '../Constants';
import { getCategoryList } from './therapeuticCategoryServices';

function TherapeuticCategoryList({ categoryList, fetchCategoryList }) {
  const [isDialogOpen, toggleDialog] = useState(false);
  const [categories, updateCategories] = useState(categoryList);

  useEffect(() => {
    if (categoryList.length < 1) fetchCategoryList();
  }, []);

  useEffect(() => {
    updateCategories(categoryList);
  }, [categoryList]);

  const [categoryToEdit, setCategoryToEdit] = useState(null);
  const [dialogMode, changeDialogMode] = useState(dialogModes.add);

  const addCategory = () => {
    changeDialogMode(dialogModes.add);
    setCategoryToEdit(null);
    toggleDialog(true);
  };

  const editCategory = category => {
    changeDialogMode(dialogModes.update);
    setCategoryToEdit({
      ...category,
    });
    toggleDialog(true);
  };

  const onSearch = e => {
    const filteredList = filter(categoryList, category =>
      includes(category.name.toUpperCase(), e.target.value.toUpperCase())
    );
    updateCategories(filteredList);
  };

  return (
    <React.Fragment>
      <CategoryUpsert
        isDialogOpen={isDialogOpen}
        toggleDialog={toggleDialog}
        dialogMode={dialogMode}
        categoryToEdit={categoryToEdit}
        changeDialogMode={changeDialogMode}
        setCategoryToEdit={setCategoryToEdit}
      />
      <Grid
        container
        style={{
          flexGrow: 1,
          marginTop: '16px',
        }}
        spacing={4}
        direction="column"
      >
        <Grid
          item
          style={{
            flexGrow: 1,
          }}
        >
          <Paper
            style={{
              padding: 8,
            }}
          >
            <Grid
              container
              style={{
                flexGrow: 1,
              }}
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography variant="h6">Therapeutic Area</Typography>
              </Grid>
              <Grid item>
                <FormControl>
                  <Input
                    id="input-with-icon-adornment"
                    startAdornment={
                      <InputAdornment position="start">
                        <Search color="primary" />
                      </InputAdornment>
                    }
                    onChange={onSearch}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={addCategory}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid
          item
          style={{
            flexGrow: 1,
          }}
        >
          {categories.map(category => (
            <TherapeuticCategory
              category={category}
              editCategory={editCategory}
            />
          ))}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  categoryList: state.therapeuticCategory.categoryList,
});

const mapDispatchToProps = dispatch => ({
  fetchCategoryList: () => dispatch(getCategoryList()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TherapeuticCategoryList);



// WEBPACK FOOTER //
// ./src/therapeuticCategory/TherapeuticCategoryList.js